import type React from 'react';

import { BlockStack, Box, Icon, InlineStack } from '@shopify/polaris';
import { CheckIcon } from '@shopify/polaris-icons';
import { cls } from '~/utils';

export interface GOptionListOption {
  value: string;
  label: React.ReactNode;
}

export interface GOptionListProps {
  options: GOptionListOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

export function GOptionList({ options, selected, onChange }: GOptionListProps) {
  const handleSelect = (value: string) => {
    onChange([value]);
  };

  const handleKeyDown = (event: React.KeyboardEvent, value: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleSelect(value);
    }
  };

  return (
    <Box padding="150">
      <BlockStack gap="100">
        {options.map((option) => {
          const isSelected = selected.includes(option.value);
          return (
            <div
              key={option.value}
              role="option"
              aria-selected={isSelected}
              tabIndex={0}
              onClick={() => handleSelect(option.value)}
              onKeyDown={(e) => handleKeyDown(e, option.value)}
              className={cls('p-1.5 pl-4 rounded-lg cursor-pointer', {
                'bg-[#F1F1F1]': isSelected,
                'hover:bg-[#F1F1F1]': !isSelected,
              })}
            >
              <InlineStack align="space-between" blockAlign="center" wrap={false} gap="200">
                <Box minWidth="0">{option.label}</Box>
                {isSelected && (
                  <Box>
                    <Icon source={CheckIcon} />
                  </Box>
                )}
              </InlineStack>
            </div>
          );
        })}
      </BlockStack>
    </Box>
  );
}
